import Vue from 'vue';
import Vuex from 'vuex';
import createMultiTabState from 'vuex-multi-tab-state';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    articleFontSize: 'm',
    lang: '',
  },
  mutations: {
    SET_ARTICLE_FONT_SIZE(state, value) {
      state.articleFontSize = value;
    },
    SET_DETAIL_PAGE_LANG(state, value) {
      state.lang = value;
    }
  },
  actions: {},
  modules: {},
  plugins: [createMultiTabState({
    statesPaths: ['articleFontSize']
  })],
});
